import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import {UserService} from '../user.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isLogged()) {
      this.router.navigate(['/auth']);
    } else {
      return true;
    }
  }
}

@Injectable({providedIn: 'root'})
export class LoginGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLogged()) {
      this.router.navigateByUrl('').then();
    } else {
      return true;
    }
  }
}

@Injectable({providedIn: 'root'})
export class AdminGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router,
              private userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let role = 'user';
    const user = this.userService.record_change$.getValue();
    if (user != undefined) {
      role = user.role;
    } else {
      role = this.authService.tokenForm.role;
    }
    if (!(this.authService.isLogged() && role == 'admin')) {
      this.router.navigateByUrl('/activity').then();
    } else {
      return true;
    }
  }
}

@Injectable({providedIn: 'root'})
export class HotelAdminGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router,
              private userService: UserService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let role = 'user';
    const user = this.userService.record_change$.getValue();
    if (user != undefined) {
      role = user.role;
    } else {
      role = this.authService.tokenForm.role;
    }
    if (!(this.authService.isLogged() && (role == 'admin' || role == 'hoteladmin'))) {
      this.router.navigateByUrl('/activity').then();
    } else {
      return true;
    }
  }
}
